const colors = {
  background: {
    main: '#F9F9F9',
  },
  lightBackground: {
    main: '#D3E8D4',
  },
  primary: {
    main: '#087F66',
  },
  secondary: {
    main: '#087F66',
  },
  error: {
    main: '#FE0009',
  },
  success: {
    main: '#028E59',
  },
  text: {
    primary: '#333333',
    secondary: '#FFF',
  },
  warning: {
    main: '#F9B41E',
  },
  input: {
    background: '#FFF',
    label: '#333333',
    border: '#333333',
  },
  alternative: {
    contrast: '#EFEFEF',
  },
  stepper: {
    icon: '#FFF',
    line: '#FFF',
    text: '#FFF',
  },
};

export default colors;
